module.exports = __webpack_public_path__ + "assets/klarna.f48499e8.png";


//////////////////
// WEBPACK FOOTER
// ../source/assets/klarna.png
// module id = 1220
// module chunks = 26